import type { ComponentProps } from 'react'
import { StackableFusuma } from './StackableFusuma'

type Props = Omit<ComponentProps<typeof StackableFusuma>, 'close' | 'willBeUnmounted'>

export function GuideFusuma({ children, ...props }: Props) {
  return (
    <StackableFusuma {...props} willBeUnmounted={isTrue}>
      {children}
    </StackableFusuma>
  )
}

// 画面遷移ではこの先に進まないので
function isTrue() {
  return true
}
